/**
 * Client-only mount gate — children render only after browser hydration.
 * Keeps SSR HTML anonymous (no cart token / device / analytics side effects).
 */

import { ReactNode, useEffect, useState } from 'react';

export function ClientOnly({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) return <>{fallback}</>;
  return <>{children}</>;
}
